import { useSelector } from "react-redux";
import { currentSelectedLanguage } from "../../../../StateManagement/actions";
import { useRef } from "react";
import { AppContext } from "../../../../AppContext";


const tabMap = {
  'Personal': 'personalTab',
  'Company': 'companyTab',
  'Admin': 'AdminTab'
};


const useGeneralControlData = () => {
  const selectedLanguage = useSelector(currentSelectedLanguage);
  const defaultSetting = useSelector((state) => state.settings.defaultSetting);
  const settings = useSelector((state) => state.settings);
  //const excludeControls = useSelector((state) => state.settings.excludeControls);
  const lookupData = useSelector((state) => state.settings.lookupData);
  const eDisclosureSecurityLevels = useRef([]);
  const tabKey = tabMap[settings.settingFor === "User" ? "Personal" : settings.settingFor];

  let controls = [];

  let commonSettings = [];
  let configLevel = "";
  let getDefaultSetting = {};
  let contentSecuritySettingId = "";
  if (settings[tabKey]?.selectedTab === "DirectSendDefaults") {
    getDefaultSetting = settings[tabKey]?.settingsData.find(s => s.settingFor === defaultSetting) || {};
    configLevel = getDefaultSetting?.configLevel;
    commonSettings = getDefaultSetting?.commonSettings;
  }
  else if (settings[tabKey]?.selectedTab === "ContentSecurity") {
    configLevel = settings[tabKey]?.settingsData[0]?.configLevel;
    commonSettings = settings[tabKey]?.settingsData[0]?.commonContentSecuritySetting;
    contentSecuritySettingId = settings[tabKey]?.settingsData[0]?.id;
  }

  else {
    configLevel = settings[tabKey]?.settingsData[0]?.configLevel;
    commonSettings = settings[tabKey]?.settingsData;
  }

  const createSettingControlObject = (id, type, label, controlType, options = [], showTooltip = false, tooltip = "", level = "common", isGroupedControl = false, extendClassName = "", placeholder = "", preSelect = false) => {
    let setting = {};
    let className = `mb-3 row align-items-center mx-1 ${settings.settingFor === "User" ? extendClassName : settings.defaultSetting === "RApp" ? "mt-comapny-11rm" : ""}`;
    let isProfileTab = false;
    if (settings[tabKey]?.selectedTab === "Profile") {
      setting.keyValue = commonSettings[type];
      setting.lockSetting = "true";
      isProfileTab = true;
    } else {
      if (type === "DefaultSettingsFor") {
        setting = {
          keyValue: defaultSetting === "Gateway" ? "0" : "1",
          isLock: "false",
          isOverride: "false",
        }
      } else {
        setting = commonSettings?.find(s => s.type?.trim() === type?.trim()) || {};

      }
    }
    if (type === "DateFormat" && setting.keyValue) {
      const colonIndex = setting.keyValue.indexOf(":");
      if (colonIndex !== -1) {
        const dateFormat = setting.keyValue
          .substr(colonIndex + 1)
          .trim();
        localStorage.setItem("DateFormatValueOriginal", dateFormat.toUpperCase());
      }
    }

    if (setting?.keyCollection?.length > 0) {
      eDisclosureSecurityLevels.current = setting.keyCollection?.map((item, index) => {
        return {
          id: index,
          label: (item.level === "L1" ? selectedLanguage.LstLanguageCodes.UI_TrackViews : item.level === "L2" ? selectedLanguage.LstLanguageCodes.UI_TrackReaders : selectedLanguage.LstLanguageCodes.UI_LimitReaders),
          level: item.level,
          levelFlag: item.levelFlag ? "true" : "false",
          ...item
        }
      }) || [];
    }

    const isDirectSendDefaultTab = settings[tabKey]?.selectedTab === "DirectSendDefaults";
    const isContentSecurityTab = settings[tabKey]?.selectedTab === "ContentSecurity";
    const isAdminDocumentTab = settings[tabKey]?.selectedTab === "Document";
    let isOverride = isDirectSendDefaultTab || isContentSecurityTab ? setting.isOverride : ((isAdminDocumentTab && type !== "maxViewsPerDocument") || (type === "MaxPagesPerRPD" || type === "ImageResolution")) ? 'false' : setting.overrideUserSetting;
    // let isLock = isDirectSendDefaultTab || isContentSecurityTab ? setting.isLock : ((isAdminDocumentTab && type === "DirectSendDefaults")|| (!isAdminDocumentTab && (type === "MaxPagesPerRPD"|| type === "ImageResolution"))) ? 'false' : setting.lockSetting;

    let isLock = isDirectSendDefaultTab || isContentSecurityTab
      ? setting.isLock
      : ((isAdminDocumentTab && (type === "DirectSendDefaults" || type === "DateControlFormat" || type === "ExcelSupport")) || (!isAdminDocumentTab && (type === "MaxPagesPerRPD" || type === "ImageResolution")))
        ? 'false'
        : setting.lockSetting;
    const settingId = isDirectSendDefaultTab ? getDefaultSetting?.id : isContentSecurityTab ? contentSecuritySettingId : setting.id;
    const showLockIconOnDisable = isDirectSendDefaultTab || isContentSecurityTab ? setting.isLock === 'true' : setting.lockSetting === 'true';

    // if(type === "maxViewsPerDocument"  && !isAdminDocumentTab){
    //   if(setting.prevLock === "true"){
    //     isLock = "true";
    //   }
    // }

    let value = "";
    if (type === "LandingPage" && setting.keyValue?.includes('_')) {
      value = setting.keyValue?.split('_')[0];
    } else {
      value = setting.keyValue;
    }

    let showHistory = true;
    if ((type === "EDisclosure" && isGroupedControl && eDisclosureSecurityLevels.current.length > 0) || type === "LandingPage_ManageItem") {
      showHistory = false;
    }

    if (options?.length > 0 && (type === "ServiceLanguage" || type === "AppLanguage")) {
      const matchedOption = options.find(option => option.key?.toLowerCase() === value?.toLowerCase());
      if (matchedOption) {
        value = matchedOption.key;
      }
    }

    if (type === "MaxReadsperReader" || type === "maxViewsPerDocument") {
      value = value === "0" ? "" : value;
    }

    let disableSharevotes = false;
    if (type === "ShareVotes") {
      disableSharevotes = commonSettings.find((c) => c.type === "Voting" && c.keyValue === "false") ? true : false;
      isOverride = disableSharevotes ? "false" : isOverride;
      isLock = disableSharevotes ? "false" : isLock;
    }


    return {
      id,
      controlType,
      label: selectedLanguage.LstLanguageCodes[label],
      containerClassname: className,
      isShowToolTip: showTooltip,
      tooltip,
      options,
      isShowLockIconOnDisable: showLockIconOnDisable,//isLock === "false" ? false : true,
      value: (value && value !== "") ? value : (controlType === "Dropdown" && options[0]?.keyValue) || "",
      settingType: type,
      settingId: settingId,
      level,
      Override: isOverride || "",
      Lock: isLock || "",
      configLevel: (isDirectSendDefaultTab || isContentSecurityTab ? configLevel : setting?.configLevel),
      placeholder,
      preSelect,
      isGroupedControl,
      showHistory,
      ...(type === "ShareVotes" && {
        disableSharevotes: disableSharevotes,
      }),
      ...(isGroupedControl && {
        disableTermsOfService: (commonSettings.find((c) => c.type === "EDisclosure" && c.keyValue === "false")) ? true : false,
        eDisclosureSecurityLevels: eDisclosureSecurityLevels.current.map(item => ({
          ...item,
          disabled: commonSettings.find(c => c.type === "EDisclosure" && c.keyValue === "false") ? true : false
        }))
      }),
      ...(isProfileTab && { isProfileTab }),
      ...(isAdminDocumentTab && type !== "maxViewsPerDocument" && {
        disableOverrideForAdminDocument: true
      }),
      ...(isAdminDocumentTab && (type === "DirectSendDefaults" || type === "ContentSecurity" || type === "DateControlFormat" || type === "ExcelSupport") && {
        disableLockForAdminDocument: true
      }),
      ...(type === "MaxPagesPerRPD" || type === "ImageResolution") && !isAdminDocumentTab && setting.prevLock === "true" && {
        disableAdminLockedControls: true
      },
      ...((type === "MaxPagesPerRPD" || type === "ImageResolution") && (settings.settingFor === 'Company' && configLevel !== "User") && {
        disableOverrideLockControls: true
      }),
      ...(type === "RPDLite" && settings.settingFor === 'Company' && {
        disableOverrideLockControls: true
      })
    };
  };

  if (settings[tabKey]?.selectedTab === "Profile") {
    controls = [
      createSettingControlObject("0", "firstName", "UI_FirstName", "Textbox", [], false, "", "common", false, "mt-5r"),
      createSettingControlObject("1", "lastName", "UI_LastName", "Textbox"),
      createSettingControlObject("2", "email", "UI_Email", "Textbox"),
      createSettingControlObject("3", "companyName", "UI_CompanyName", "Textbox"),
    ];
  } else if (settings[tabKey]?.selectedTab === "General") {
    controls = [
      createSettingControlObject("0", "DateFormat", "UI_DateFormat", "Dropdown", lookupData?.dateFormatOptions, false, "", "common", false, "mt-10rm"),
      ...(AppContext.IsEnableTimeZone === true ? [createSettingControlObject("1", "TimeZone", "UI_TimeZone", "Dropdown", lookupData?.TimeZoneOptions)] : []),
      createSettingControlObject("2", "ServiceLanguage", "UI_ServiceLanguage", "Dropdown", lookupData?.serviceLanguageOptions, true, selectedLanguage.LstLanguageCodes.UI_ServiceLanguageInfo),
      createSettingControlObject("3", "AppLanguage", "UI_AppLanguage", "Dropdown", lookupData?.appLanguageOptions),
      createSettingControlObject("4", "LandingPage", "UI_LandingPage", "Dropdown", lookupData?.landingPageOptions?.landingOptions),
    ];
    const setting = commonSettings.find(s => s.type?.trim() === "LandingPage") || {};
    if (setting && setting.keyValue?.includes("Manage")) {
      controls.push(createSettingControlObject("4", "LandingPage_ManageItem", "", "Dropdown", lookupData?.landingPageOptions?.manageOptions, false, "", "common", true));
    }
  } else if (settings[tabKey]?.selectedTab === "DefaultDocumentSettings") {
    controls = [
      createSettingControlObject("0", "AccessControl", "UI_AccessControl", "Dropdown", lookupData?.accessControlOptions, false, "", "common", false, "mt-10rm"),
      createSettingControlObject("1", "BannedRegions", "UI_BannedRegions", "custom-Dropdown", lookupData?.bannedRegionOptions),
      createSettingControlObject("2", "AllowedIP", "UI_AllowedIP", "custom-Textbox"),
      createSettingControlObject("3", "Launches", "UI_Launches", "Dropdown", lookupData?.launchesOptions, true, selectedLanguage.LstLanguageCodes.UI_LaunchesInfo,),
      createSettingControlObject("4", "Expires", "UI_Expires", "Textbox", [], true, selectedLanguage.LstLanguageCodes.UI_ExpiresInfo, "common", false, "", selectedLanguage.LstLanguageCodes.UI_Expirydays),
      createSettingControlObject("5", "RestrictToDomains", "UI_RestrictToDomains", "Textbox", [], false, "", "common", false, "", selectedLanguage.LstLanguageCodes.UI_ExampleORGExample),
      createSettingControlObject("6", "Watermark", "UI_Watermark", "Dropdown", lookupData?.watermarkOptions),
      ...(settings.settingFor === 'Company' && configLevel !== "User" ? [createSettingControlObject("7", "MaxPagesPerRPD", "UI_MaxpagesperRPD", "Dropdown", lookupData?.maxPagesPerRPDOptions)] : []),
      createSettingControlObject("8", "maxViewsPerDocument", "UI_MaxviewsPerDocument", "Textbox", [], false, "", 'common', false, "", selectedLanguage.LstLanguageCodes.UI_Unlimited),
      ...(settings.settingFor === 'Company' && configLevel !== "User" ? [createSettingControlObject("9", "ImageResolution", "UI_Documentresolution", "Dropdown", lookupData?.imageResolutionOptions)] : []),
      createSettingControlObject("10", "MaxReadsperReader", "UI_MaxReadsperReader", "Textbox", [], false, "", 'common', false, "", selectedLanguage.LstLanguageCodes.UI_Unlimited),
      createSettingControlObject("11", "SideNote", "UI_SideNote", "Text Area"),
      createSettingControlObject("12", "AllowResponseTo", "UI_AllowResponsesTo", "Checkbox", [], false, "", "common", false, "", "", true),
      createSettingControlObject("13", "SendVerificationCode", "UI_SendVerificationCode", "Checkbox", [], false, "", "common", false, "", "", true),
      createSettingControlObject("14", "ProofOfSending", "UI_ProofOfSending", "Checkbox", [], false, "", "common", false, "", "", true),
      createSettingControlObject("15", "DisplayDistributionList", "UI_DisplayDistributionlist", "Checkbox", [], false, "", "common", false, "", "", true),
      createSettingControlObject("16", "Voting", "UI_Voting", "Checkbox", [], false, "", "common", false, "", "", true),
      createSettingControlObject("17", "ShareVotes", "UI_ShareVotes", "Checkbox", [], false, "", "common", false, "", "", true),
      createSettingControlObject("18", "NotificationOfReading", "UI_NotificationofReading", "Checkbox", [], false, "", "common", false, "", "", true),
      ...(!AppContext.ContentSecurity ? [createSettingControlObject("19", "Identifyleakers", "UI_IdentifyLeakers", "Checkbox", [], false, "", "common", false, "", "", true)] : []),
      createSettingControlObject("20", "TimeStamp", "UI_TimeStamp", "Checkbox", [], false, "", "common", false, "", "", true),
      createSettingControlObject("21", "CanPrint", "UI_CanPrint", "Checkbox", [], false, "", "common", false, "", "", true),
      createSettingControlObject("24", "MaxPrintsPerReader", "UI_MaxPrintsPerReader", "Textbox", [], false, "", 'common', false, "", selectedLanguage.LstLanguageCodes.UI_Unlimited),
      createSettingControlObject("25", "MaxPrintsPerDocument", "UI_MaxPrintsPerDocument", "Textbox", [], false, "", 'common', false, "", selectedLanguage.LstLanguageCodes.UI_Unlimited),
      createSettingControlObject("22", "PageLevelRestrictions", "UI_Pagelevelrestrictions", "Radio"),
      createSettingControlObject("23", "SMSAuthentication", "UI_SMSAuthentication", "Radio"),

    ];
  } else if (settings[tabKey]?.selectedTab === "DirectSendDefaults") {
    controls = [
      createSettingControlObject("0", "DefaultSettingsFor", "UI_DefaultSettingsFor", 'Dropdown', lookupData?.defaultSettingsForOptions, false, "", "common", false, "mt-10rm"),
    ]
    if (defaultSetting === "Gateway") {
      controls.push(createSettingControlObject("1", "Gateway", "UI_Gateway", "Dropdown", lookupData?.gatewayOptions, true, selectedLanguage.LstLanguageCodes.UI_GatewayInfo));
      controls.push(createSettingControlObject("2", "GatewayAccessControl", "UI_AccessControl", "Dropdown", lookupData?.accessControlOptions, false, selectedLanguage.LstLanguageCodes.UI_GatewayAccessControlInfo));
    }
  } else if (settings[tabKey]?.selectedTab === "Advance") {
    controls = [
      createSettingControlObject("0", "PasscodeExpiryPolicy", "UI_PasscodeExpiryPolicy", "Dropdown", lookupData?.passcodeExpiryPolicyOptions, false, "", "common", false, "mt-10rm"),
      createSettingControlObject("1", "PasscodeLength", "UI_PasscodeLength", "Dropdown", lookupData?.PasscodeLengthOptions, false, "", "common", false, ""),
      createSettingControlObject("2", "TrackKilledDocument", "UI_TrackKilledDocuments", "Radio", [], false, "", "common"),
      createSettingControlObject("3", "EDisclosure", "UI_EDisclosure", "Radio"),
      createSettingControlObject("4", "EDisclosure", "", "Checkbox", [], false, "", "common", true),
      createSettingControlObject("5", "TermsOfService", "UI_TermsOfService", "RichTextEditor", [], false, "", "common", true)
    ]
  } else if (settings[tabKey]?.selectedTab === "Document") {
    controls = [
      createSettingControlObject("0", "MaxPagesPerRPD", "UI_MaxpagesperRPD", "Dropdown", lookupData?.maxPagesPerRPDOptions),
      createSettingControlObject("1", "maxViewsPerDocument", "UI_MaxviewsPerDocument", "Textbox", [], false, "", 'common', false, "", selectedLanguage.LstLanguageCodes.UI_Unlimited),
      createSettingControlObject("2", "ImageResolution", "UI_Documentresolution", "Dropdown", lookupData?.imageResolutionOptions),
      createSettingControlObject("3", "DirectSendDefaults", "UI_DirectSendDefaults", "Radio"),
      createSettingControlObject("4", "ContentSecurity", "UI_ContentSecurity", "Radio"),
      createSettingControlObject("5", "DateControlFormat", "UI_TimeControl", "Radio"),
      ...(AppContext.IsEnableExcelSupport ? [createSettingControlObject("6", "ExcelSupport", "UI_ExcelSupport", "Radio")] : []),];
  } else if (settings[tabKey]?.selectedTab === "ContentSecurity") {
    controls = [
      createSettingControlObject("0", "IDLeakers", "UI_IDLeakers", "Radio", [], false, "", "commonContentSecuritySetting", false, "mt-10rm"),
      createSettingControlObject("1", "IDLeakersType", "UI_IDLeakersType", "Dropdown", lookupData?.IDLeakersTypeOptions, false, "", "commonContentSecuritySetting", false, ""),
    ];
  }
  else if (settings[tabKey]?.selectedTab === "Storage") {
    controls = [
      createSettingControlObject("0", "RPDLite", "UI_RPDLite", "Radio", [], false, "", "common", false, "mt-10rm")
    ]
  }
  return controls;
};

export default useGeneralControlData;